import css from 'styled-jsx/css';
import { zIndex } from '../theme/theme';

const style = css.global`
  .licenses-wrapper {
    z-index: ${zIndex.allAroundModal};
  }
  .licenses-wrapper .ant-modal-content {
    padding: 15px;
    min-height: 300px;
  }
  .licenses-wrapper .ant-modal-header {
    border-bottom: 0;
    padding-bottom: 20px;
    padding-top: 10px;
  }
  .licenses-wrapper .ant-modal-title {
    font-size: 17px;
  }
  .licenses-wrapper .ant-modal-body {
    padding: 15px;
    padding-top: 0;
    padding-left: 7px;
  }
  .licenses-wrapper .ant-modal-close {
    width: 50px;
    height: 50px;
    color: black;
  }
  .licenses-wrapper .modal-item {
    cursor: pointer;
  }
`;

export default style;
